import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import { globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { useSnackbar } from "notistack";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";
import { trackActivity } from "../../../../utils/mixpanel";
import { Autocomplete } from "@material-ui/lab";

const AddEditEngineLlpsConfig = ({ toggleModalFn, modalData, getResponseBack, circularLoader }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [error, setError] = useState({ modal: false, data: null })
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(() => {
        if (modalData?.callTo === 'parent') {
            return {
                id: modalData?.data?.id || null,
                name: modalData?.data?.name || '',
            };
        } else {
            return {
                id: modalData?.data?.id || null,
                module: modalData?.data?.module || modalData?.data?.id || null,
                name: modalData.type === 'add' ? '' : modalData?.data?.name || '',
                llp_type: modalData.type === 'add' ? '' : modalData?.data?.llp_type || '',
                remarks: modalData.type === 'add' ? '' : modalData?.data?.remarks || null,
            };
        }
    });

    const onFieldChange = (key, value) => {
        setData(prev => ({ ...prev, [key]: value }))
    }

    const isDataChanged = () =>{
        const originalData = modalData?.data || {};
        
        return(
            data?.name !== originalData?.name ||
            data?.llp_type?.value !== originalData?.llp_type?.value ||
            data?.remarks !== originalData?.remarks
        );
    };

    const getPayload = () => {
        if (modalData?.callTo === 'parent') {
            return {
                id: data?.id || null,
                name: data?.name || ''
            }
        } else {
            return {
                id: data?.id || null,
                module: data?.module || null,
                name: data?.name || null,
                llp_type: data?.llp_type || null,
                remarks: data?.remarks || null,
            }
        }
    }

    const isEdit = modalData?.type === 'edit';
    const isParent = modalData?.callTo === 'parent';

    const handleSumbit = () => {
        let validationInputs = !isParent ? {
            name: data?.name?.trim() ? '' : 'Please Enter Name',
            llp_type: data?.llp_type ? '' : 'Please select LLP Type'
        } : {name: data?.name?.trim() ? '' : 'Please Enter Name',}
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            const payload = getPayload();
            const apiUrl = isParent
                ? `config-data/llp-module/${isEdit ? 'bulk-update/' : ''}`
                : `config-data/llp-description/${isEdit ? 'bulk-update/' : ''}`

            const apiMethod = isEdit ? globalPutService : globalPostService;

            setLoading(true)
            apiMethod(apiUrl, [payload])
                .then(response => {
                    setLoading(false)
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        getResponseBack();
                        toggleModalFn();
                        trackActivity('Console Management', {
                            event_desc: isEdit ? `${isParent ? 'Engine Module' : 'Module Description'} Data Updated Successfully` : `${isParent ? 'Engine Module' : 'Module Description'} Data Added Successfully`,
                            page_title: 'Config Data : Engine LLP Config',
                            event_type: isEdit ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details });
                        trackActivity('Console Management', {
                            event_desc: isEdit ? `${isParent ? 'Engine Module' : 'Module Description'} Data Updation Failed` : `${isParent ? 'Engine Module' : 'Module Description'} Data Addition Failed`,
                            page_title: 'Config Data : Engine LLP Config',
                            event_type: isEdit ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }


    return (
        <Dialog open={true} className='console-management-modal'>
            <DialogTitle>
                {modalData?.callTo === 'parent' ? modalData?.type === 'add' ? 'Add Module' : 'Edit Module' : modalData?.callTo === 'child' ? modalData?.type === 'edit' ? 'Edit Module Description' : 'Add Module Description' : ''}
            </DialogTitle>
            <DialogContent dividers>
                <div style={{ width: "350px" }}>
                    <Grid container spacing={1}>
                        {modalData?.callTo === 'parent' && (
                            <Grid item md={12}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    required
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>)}
                        {modalData?.callTo === 'child' && (
                            <>
                                <Grid item md={12}>
                                    <TextField
                                        name='name'
                                        label='Name'
                                        required
                                        value={data?.name || ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ maxLength: 150 }}
                                        onChange={(e) => onFieldChange('name', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                        error={error?.name || ''}
                                        helperText={error?.name || ''}
                                        onFocus={() => setError({...error, name: ''})}
                                    />
                                </Grid>
                                {(() => {
                                    let options = [{ label: 'Primary LLP', value: 1 }, { label: 'Secondary LLP', value: 2 }, { label: 'Both', value: 3 }];
                                    return (
                                        <Grid item md={12}>
                                            <Autocomplete
                                                options={options}
                                                getOptionLabel={option => option.label}
                                                disableClearable={true}
                                                name="llp_type"
                                                value={data?.llp_type}
                                                onChange={(e, value) => onFieldChange('llp_type', value)}
                                                renderInput={params => <TextField {...params} label="LLP Type" margin="normal" error={error?.llp_type || ''} helperText={error?.llp_type || ''} onFocus={() => setError({...error, llp_type: ''})} fullWidth required InputLabelProps={{ shrink: true }} variant='outlined' />}
                                            />
                                        </Grid>
                                    )
                                })()}
                                <Grid item md={12}>
                                    <TextField
                                        name='remarks'
                                        label='Remarks'
                                        value={data?.remarks || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        rows={3}
                                        inputProps={{ maxLength: 255 }}
                                        onChange={(e) => onFieldChange('remarks', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Engine LLP Config', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${isEdit ? 'Edit' : 'Add'} ${isParent ? 'Engine Module' : 'Module Description'} form` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button onClick={() => { handleSumbit(); trackActivity('Console Management', { page_title: 'Config Data : Engine LLP Config', item_type: 'Save Button', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${isEdit ? 'Edit' : 'Add'} ${isParent ? 'Engine Module' : 'Module Description'} form` }) }} color="primary" size='small' variant="contained" disabled={isLoading || !isDataChanged()}>{circularLoader ? <CircularProgress size={20} /> : 'Save'} </Button>
            </DialogActions>
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item}
                />)}
        </Dialog>
    );
};

export default AddEditEngineLlpsConfig